/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Loading_HlsInputs */



/**
* | output |
* | --- |
* | "Loading HLS Manifest..." |
*
* @param {Load_Project_File_Status_Loading_HlsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_loading_hls = /** @type {((inputs?: Load_Project_File_Status_Loading_HlsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Loading_HlsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement du manifeste HLS...")
	if (locale === "de") return /** @type {LocalizedString} */ ("HLS-Manifest wird geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento del manifesto HLS in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка манифеста HLS...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando manifiesto HLS...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载 HLS 清单...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("HLS マニフェストを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("HLS मैनिफेस्ट लोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando o manifesto HLS...")
	return /** @type {LocalizedString} */ ("Loading HLS Manifest...")
});